<template>
  <div class="min-vh" v-if="useSlaFromChannelSetting">
    <div class="d-flex justify-content-between p-3 p-sm-0">
      <h1 class="mb-0 header-main text-uppercase d-inline">SLA POLICY</h1>
      <button class="create-button" @click="handleCreate()">
        <font-awesome-icon icon="plus-square" />
        <span class="ml-2"> CREATE</span>
      </button>
    </div>
    <div class="mt-3 main-theme bg-white-border p-3">
      <b-table
        responsive
        striped
        hover
        class="table-list"
        :items="items"
        :fields="fields"
        :busy="isBusy"
        :per-page="filter.perPage"
        :current-page="filter.pageNo"
        show-empty
        :empty-text="$t('noData')"
      >
        <template v-slot:cell(name)="data">
          <div class="text-center">
            {{ data.item.name ? data.item.name : "-" }}
          </div>
        </template>
        <template v-slot:cell(waitDueMinute)="data">
          <div class="text-center">
            {{ data.item.waitDueIsEnable == 1 ? data.item.waitDueMinute : "-" }}
          </div>
        </template>
        <template v-slot:cell(resolutionDueMinute)="data">
          <div class="text-center">
            {{
              data.item.resolutionDueIsEnable == 1
                ? data.item.resolutionDueMinute
                : "-"
            }}
          </div>
        </template>
        <template v-slot:cell(resolutionTimeMinute)="data">
          <div class="text-center">
            {{
              data.item.resolutionTimeEnable == 1
                ? data.item.resolutionTimeMinute
                : "-"
            }}
          </div>
        </template>
        <template v-slot:cell(nonBusinessTime)="data">
          <div class="text-center">
            {{
              data.item.channelBusinessHourEnable == 1
                ? data.item.nonBusinessTime
                : "-"
            }}
          </div>
        </template>
        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(id)="data">
          <div class="d-flex justify-content-center">
            <b-link
              class="text-link"
              @click="onEdit(data.item.platformConfigId)"
            >
              <font-awesome-icon
                icon="pencil-alt"
                class="text-warning"
                title="Edit"
              />
            </b-link>
            <b-link
              class="text-link ml-3"
              @click="onDeleteModal(data.item)"
              v-if="data.item.platformConfigId !== 0"
            >
              <font-awesome-icon
                icon="trash-alt"
                class="text-danger"
                title="Delete"
              />
            </b-link>
          </div>
        </template>
      </b-table>
      <b-row class="no-gutters px-3 px-sm-0">
        <b-col
          class="form-inline justify-content-center justify-content-sm-between"
        >
          <div v-if="rows > 0" class="my-auto">
            Showing {{ startPage | numeral("0,0") }} to
            {{ endPage | numeral("0,0") }} of
            {{ rows | numeral("0,0") }} entires
          </div>
          <div v-else class="my-auto">{{ rows || 0 }} entire</div>
          <div class="d-sm-flex m-3">
            <b-pagination
              v-model="filter.pageNo"
              :total-rows="rows"
              :per-page="filter.perPage"
              class="m-md-0"
              @change="pagination"
              align="center"
            ></b-pagination>
            <b-form-select
              class="select-pagination ml-md-3 w-auto"
              v-model="filter.perPage"
              @change="handleChangePerpage"
              :options="pageOptions"
            ></b-form-select>
          </div>
        </b-col>
      </b-row>
    </div>
    <ModalAlertConfirm
      :msg="$t('confirmDelete')"
      :text="modalMsgDelete"
      :btnConfirm="$t('delete')"
      colorBtnConfirm="danger"
      :btnCancel="$t('cancel')"
      ref="ModalAlertConfirm"
      @confirm="onDeleteData"
    />
  </div>
  <SettingSLAPolicyPage v-else />
</template>

<script>
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import SettingSLAPolicyPage from "@/views/pages/setting-sla-policy/Detail";

export default {
  name: "SettingSLAPolicy",
  components: {
    ModalAlertConfirm,
    SettingSLAPolicyPage,
  },
  data() {
    return {
      modalMsgDelete: "",
      bodyDelete: {
        id: 0,
      },
      isBusy: false,
      startPage: 1,
      endPage: 10,
      rows: 0,
      filter: {
        pageNo: 1,
        perPage: 10,
      },
      fields: [
        {
          key: "platformName",
          label: "Channel Name",
        },
        {
          key: "name",
          label: "Brand",
          thClass: "brand-th",
        },

        {
          key: "waitDueMinute",
          label: "First Response Time(Min)",
        },
        {
          key: "resolutionDueMinute",
          label: "Every Response Time(Min)",
        },
        {
          key: "resolutionTimeMinute",
          label: "Resolution Time(Min)",
        },
        {
          key: "nonBusinessTime",
          label: "After Business Hour(Min)",
        },
        {
          key: "id",
          label: "Action",
          class: "w-action",
        },
      ],
      pageOptions: [
        { value: 10, text: `10 / Page` },
        { value: 30, text: `30 / Page` },
        { value: 50, text: `50 / Page` },
        { value: 100, text: `100 / Page` },
      ],
      items: [],
      useSlaFromChannelSetting:
        this.$store.getters.getBrandList()[0]?.useSlaFromChannelSetting,
    };
  },
  created: async function () {
    if (this.useSlaFromChannelSetting) {
      await this.pagination(1);
    }
  },
  methods: {
    getList: async function () {
      this.isBusy = true;
      await this.axios
        .get(`${this.$baseUrl}/setting/channel-setting/sla`)
        .then((data) => {
          if (data.result == 1) {
            this.items = data.detail;
            this.rows = data.detail.length;
          }
        });
      this.isBusy = false;
    },
    handleCreate() {
      this.$router.push({ path: `/setting-sla-policy/create` }).catch(() => {});
    },
    onEdit(id) {
      this.$router.push({ path: `/setting-sla-policy/${id}` }).catch(() => {});
    },
    pagination(Page) {
      this.filter.pageNo = Page;
      this.getList();
      this.getShowingPage(Page);
    },
    async getShowingPage(page) {
      let result = await this.$getShowingPage(page, this.filter);
      this.startPage = result.startPage;
      this.endPage = result.endPage;
    },
    onDeleteModal(data) {
      this.bodyDelete.id = data.platformConfigId;
      this.modalMsgDelete = `${this.$t('confirmDelete2')} ${data.name} ${this.$t('yesOrNo')}`;
      this.$refs.ModalAlertConfirm.show();
    },
    async onDeleteData() {
      this.$refs.ModalAlertConfirm.hide();
      await this.axios
        .delete(
          `${this.$baseUrl}/setting/channel-setting/sla/${this.bodyDelete.id}`
        )
        .then(async (data) => {
          if (data.result == 1) {
            this.$store.commit("UPDATE_GLOBAL_ALERT", {
              isShow: true,
              msg: data.message,
            });
            await this.pagination(1);
          } else {
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.message,
            });
          }
        })
        .catch((err) => {
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: err.message,
          });
        });
    },
    handleChangePerpage(perPage) {
      this.filter.pageNo = 1;
      this.filter.perPage = perPage;
      this.showing = this.filter.pageNo;
      this.showingTo = this.filter.perPage;
      this.getList();
      this.getShowingPage(this.filter.pageNo);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .brand-th {
  width: 400px !important;
}
</style>
